import { Alert, Loading, Section } from "@landtechnologies/components";
import { Title } from "react-migration/domains/ownership";
import { useTranslation } from "react-migration/lib";
import { PropertyInfoTitle } from "./PropertyInformation";
import { Dispatch, SetStateAction } from "react";
import { USUnitList } from "react-migration/domains/ownership/components/USUnitList";

const PropertyUnitsTitle = ({ numberOfItems }: { numberOfItems: number }) => {
  const { t } = useTranslation();
  return (
    <div className="atlas-flex atlas-flex-row atlas-gap-x-2 atlas-items-center atlas-pt-4 atlas-pb-1.5">
      <span className="atlas-flex atlas-font-semibold atlas-text-xl atlas-text-content-primary">
        {t("sites.card.ownership.units_at_this_address")}
      </span>
      {numberOfItems > 0 && (
        <span
          className="atlas-text-xs atlas-bg-background-darker atlas-text-content-secondary atlas-rounded-full atlas-h-5 atlas-px-2 atlas-py-0.5
      atlas-flex atlas-items-center atlas-justify-center atlas-font-medium"
        >
          {numberOfItems}
        </span>
      )}
    </div>
  );
};

type PropertyUnitsProps = {
  titlesByLocation: Title[];
  titlesByLocationLoading: boolean;
  setUnitInfo: Dispatch<SetStateAction<Title | undefined>>;
};

export const PropertyUnits = ({
  titlesByLocation,
  titlesByLocationLoading,
  setUnitInfo,
}: PropertyUnitsProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid="ownership-overview-property-units">
      <PropertyInfoTitle className="!atlas-m-0 !atlas-pb-4" />
      <span className="atlas-text-content-primary atlas-font-semibold">
        {t("sites.card.ownership.address")}
      </span>
      <div className="atlas-pt-0.5 atlas-pb-4 atlas-border-b atlas-border-border-divider-subtle">
        <Alert.Info>{t("sites.card.ownership.main_plot_not_found")}</Alert.Info>
      </div>
      {titlesByLocationLoading ? (
        <div className="atlas-pt-4 atlas-pb-2">
          <Loading />
        </div>
      ) : (
        <Section>
          <PropertyUnitsTitle numberOfItems={titlesByLocation.length} />
          <USUnitList
            units={titlesByLocation}
            action={(unitInfo?: Title) => setUnitInfo(unitInfo)}
          />
        </Section>
      )}
    </div>
  );
};
